import React, { useCallback, useState } from 'react';
import cx from 'clsx';

import { useAppSelector } from '../../../redux/hooks/app-hooks';

import { AnswerActions } from './Actions/Actions';
import { AnswerWrapper } from './AnswerWrapper/AnswerWrapper';
import { AnswerDescription } from './Description/Description';
import { AnswerIcon } from './Icon/Icon';
import { AnswerTopBar } from './TopBar/TopBar';
import { IAnswerProps } from './types';

import styles from './Answer.module.scss';

const noOp = () => false;

export const AnswerWebApp: React.FC<IAnswerProps> = ({ answer, onClick = () => false }) => {
    const activeAnswerUuid = useAppSelector((state) => state.answers.activeAnswerUuid);
    const [actionsRendered, setActionsRendered] = useState(false);

    const handleClick = useCallback(() => {
        onClick(answer);
    }, [answer, onClick]);

    const handleOnMouseOver = useCallback(() => {
        setActionsRendered(true);
    }, []);

    return (
        <AnswerWrapper
            answerUuid={answer.uuid}
            isActive={activeAnswerUuid === answer.uuid}
            isGrayedOut={answer.isGrayedOut}
            className={styles.wrapper}
            onClick={handleClick}
            onMouseOver={handleOnMouseOver}
        >
            <AnswerTopBar documentMetadata={answer.document_metadata} />
            <AnswerDescription answer={answer} onClick={noOp} />
            <div className={cx(styles.footer)}>
                <AnswerIcon answer={answer} onClick={noOp} />
                {actionsRendered && <AnswerActions answer={answer} />}
            </div>
        </AnswerWrapper>
    );
};
